import axios from '../config/axios.config';

window.datasource = {};
datasource.login = function (entity) {
    return axios.post(entity.path, entity.q);
};

datasource.delete = function (entity) {
    let path = entity.path || null;
    if (path == null) {
        throw new URIError();
    }
    if (path.indexOf('{id}') != -1) {
        let id = entity.data.id || null;
        if (id == null) {
            throw new TypeError('"{id}" in path requires for a property "id" in entity');
        }
        path = path.replace('{id}', id);
    }
    return axios.delete(path, entity.data);
};

datasource.resolve = function (path) {
    let q = datasource;
    if (q.hasOwnProperty('prefix')) {
        path = q.prefix + path;
    }
    if (path.indexOf('/') == 0) {
        path = path.slice(1);
    }
    return '{0}://{1}/{2}'.format(q.protocol, q.host, path);
}

datasource.entity = function (query) {
    let path = query.path || null;
    let method = query.method || 'GET';
    if (path == null) {
        throw new URIError();
    }

    if (path.indexOf('{id}') != -1) {
        let id = query.id || null;
        if (id == null) {
            throw new TypeError('"{id}" in path requires for a property "id" in query');
        }
        path = path.replace('{id}', id);
    }

    let handler = query.handler;
    if (handler != null && codepku.typeOf(handler) != 'function') {
        throw new TypeError('Property "handler" must be a function.');
    }

    let wrapper = query.wrapper;
    if (wrapper != null && codepku.typeOf(wrapper) != 'function') {
        throw new TypeError('Property "wrapper" must be a function.');
    }
    return new Promise(function (resolve, reject) {
        let options = {
            method: method,
            url: path
        };
        if (query.method == 'POST') {
            options.data = query.data;
        } else {
            options.params = query.data;
        }
        axios(options).then((response) => {
            if (response.code == 200) {
                let data = response.data;
                if (handler) {
                    handler.call(undefined, data);
                }
                if (wrapper) {
                    data = wrapper.call(undefined, data);
                }
                const consoleGroupName = 'Load data - ' + moment().format('YYYY-MM-DD HH:mm:ss');
                setTimeout(() => {
                    console.group(consoleGroupName);
                    console.info('Receive:', origin);
                    console.info('Repsond:', data);
                    console.groupEnd(consoleGroupName);
                }, 0);
                resolve(data);
            } else {
                reject(response);
            }
        }).catch((error) => {
            reject(error);
        })
    });
};

datasource.requireParams = function (params, url) {
    let rangeArr = [],
        paramUrl = '?';
    if (params && typeof params == 'object') {
        params.forEach((data) => {
            let param = '';
            for (let i in data) {
                param += i + '=' + data[i];
            }
            rangeArr.push(param);
        });
        paramUrl += rangeArr.join('&');
        return url + paramUrl;
    }
    return null;
};

datasource.downloadUrl = function (url) {
    if (url) {
        url = url.format(process.env.PROTOCOL, process.env.API_HOST + "/api")
    }
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = function (e) {
        document.body.removeChild(iframe);
    }
    document.body.appendChild(iframe);
}

export default datasource;



// WEBPACK FOOTER //
// ./src/js/datasource.js